// @flow

// eslint doesn't seem to understand this flow line
// eslint-disable-next-line
const toggleValueInArray = <T>(arr: T[] = [], value: T): T[] => {
  const index = arr.indexOf(value);
  if (index >= 0) {
    return arr.slice(0, index).concat(arr.slice(index + 1));
  }
  return arr.concat([value]);
};

export default toggleValueInArray;
